import React from 'react'
import { connect } from 'react-redux'
import { Panel, Checkbox, ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap'
import QRCode from 'qrcode-react'

import Button from '../../components/Button.jsx'
import { getText } from '../../lib/text.js'
import PushNotificationsList from './PushNotificationsList'
import NewNotificationModal from './NewNotificationModal'
import FeedbackList from "./FeedbackList"
import { getBillForProps } from '../../selectors'

type Props = {
  // from dad
  trip: Object,
  onChange: Object => void, // changes => void

  // from connect
  Activities: object, 
  route: object, 
  bill: object[]
}

class AppInfo extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { newNotificationModal: false }
  }

  props: Props

  showModal() { this.setState({ newNotificationModal: true }) }

  hideModal() { this.setState({ newNotificationModal: false }) }

  sendNotification(title, msg, type = "msg", url = "") {
    fetch(
      `/api2/sendPush/${this.props.trip._id}`, 
      {  
        method: "POST", 
        headers: { 
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ title, msg, route: { type, url }})
      })
      .then(response => response.json())
      .then(body => console.log(`sent ${body.messageCount} push notifications`))
  }

  render() {
    const { trip, onChange, Activities, route } = this.props
    const url = document.location.origin + "/api2/" + trip._id
    
    return (
      <Row>
        <Col md={7}>
          <Panel>
            <Panel.Body>
              <h2>{getText("App")}</h2>

              {
                this.state.newNotificationModal && (
                  <NewNotificationModal 
                    onCancel={() => this.hideModal()}
                    onSend={({title, msg, type, url}) => {
                      this.sendNotification(title, msg, type, url)
                      this.hideModal()
                    }}
                  />
                )
              }

              <Checkbox 
                checked={trip.appEnabled}
                onChange={evt => onChange({ appEnabled: evt.target.checked })}
              >
                Habilitar app para este cliente
              </Checkbox>
      
              {
                trip.appEnabled && (
                  <div>
                    <div style={{marginLeft: '25%'}}>
                      <QRCode 
                        value={url} 
                        logo={"/static/logo_no_letters.png"} 
                        size={256} logoWidth={128}
                        level={['L', 'M', 'Q', 'H'][0]}
                      />
                    </div>
                    <code
                      style={{margin: "auto"}}
                    >
                      {url}
                    </code>
      
                    <h3>Notificaciones: </h3>
      
                    <Panel>
                      <Panel.Heading>Suscripciones:</Panel.Heading>
                      <Panel.Body>
                        <ListGroup>
                          {
                            trip.pushSubscriptions.map(subscription => (
                              <ListGroupItem 
                                style={{position: "relative"}} 
                                key={subscription.token} 
                                header={subscription.device.deviceName}
                              >
                                {subscription.token}
                                <Button
                                  style={{ position: "absolute", top: 5, right: 5 }}
                                  glyph="remove"
                                  onClick={() => onChange({ pushSubscriptions: trip.pushSubscriptions.filter(s => s.token != subscription.token)})}
                                >
                                  Eliminar
                                </Button>
                              </ListGroupItem>
                            ))
                          }
                        </ListGroup>
                      </Panel.Body>
                      <Panel.Footer>
                        <span style={{color: "darkorange"}}>
                          {"Es recomendable que tú también te suscribas, para ver las notificaciones como el cliente ;)"}
                        </span>
                      </Panel.Footer>
                    </Panel>

                    <div style={{ marginBottom: 10 }}>
                      <Button
                        glyph="alert"
                        onClick={() => {
                          this.showModal()
                        }}
                      >
                        Immediate notification
                      </Button>
                    </div>
      
                    <PushNotificationsList 
                      trip={trip}
                      onChange={appNotifications => onChange({ appNotifications })}
                      Activities={Activities}
                      route={route}
                    />
                  </div>
                )
              }
            </Panel.Body>
          </Panel>
        </Col>

        <Col md={5}>
          <FeedbackList 
            agenda={route.agenda} 
            Activities={this.props.Activities}
            feedback={trip.feedback}
            trip={trip}
            bill={this.props.bill}
          />
        </Col>
      </Row>
    ) 
  }
}


const mapStateToProps = (state, ownProps) => ({
  Activities: state.activities, 
  route: state.routes[ownProps.trip.mainRoute], 
  bill: getBillForProps(state, ownProps), 
})

export default connect(mapStateToProps)(AppInfo)
